/* @flow */
import { ChartModel } from './chart.model';
import { CANVAS_WIDTH, CHART_AREA_RECT } from './constants';
import { formatDateWithYear } from './utils/date.utils';
import { EventTarget } from './utils/event-target';

export class Legend extends EventTarget {
    chart: ChartModel;
    container: HTMLElement;
    legend: HTMLElement;
    constructor (container: HTMLElement, chart: ChartModel) {
        super();
        this.chart = chart;
        this.container = container;
        this._render();
    }

    _render () {
        this.legend = document.createElement('div');
        this.legend.className = 'legend';
        this.legendDate = document.createElement('h4');
        this.legendDate.className = 'legend-date';
        this.legendBody = document.createElement('div');
        this.legend.appendChild(this.legendDate);
        this.legend.appendChild(this.legendBody);
        this.container.appendChild(this.legend);
        this._registerEvents();
    }

    _drawLegendItem (col, position) {
        const row = document.createElement('div');
        row.className = 'legend-item-row';
        const label = document.createElement('span');
        label.className = 'legend-item-label';
        label.textContent = col.name;
        const val = document.createElement('span');
        val.className = 'legend-item-val';
        val.textContent = col.data[position];
        val.style.color = col.color;
        row.appendChild(label);
        row.appendChild(val);
        return row;
    }

    _registerEvents () {
        this.container.addEventListener('click', (event: MouseEvent) => {
            if (event.offsetX >= CHART_AREA_RECT.x1 &&
                event.offsetX <= CHART_AREA_RECT.x2 &&
                event.offsetY >= CHART_AREA_RECT.y1 &&
                event.offsetY <= CHART_AREA_RECT.y2
            ) {
                event.stopPropagation();
                this.legend.style.display = 'block';
                let offset = event.offsetX;
                const step = CANVAS_WIDTH / (this.chart.selectEnd - 1 - this.chart.selectStart);
                const chartOffset = Math.round(offset / step) + this.chart.selectStart;
                this.legendDate.textContent = formatDateWithYear(this.chart.row.data[chartOffset]);
                offset = offset < 75 ? 75 : offset;
                offset = offset > CANVAS_WIDTH - 75 ? CANVAS_WIDTH - 75 : offset;
                this.legend.style.left = offset + 'px';
                this.legendBody.innerHTML = '';
                this.chart.columns.forEach(col => {
                    if(!col._disabled) {
                        this.legendBody.appendChild(this._drawLegendItem(col, chartOffset));
                    }
                });
            }
        });
        window.addEventListener('click', (event: MouseEvent) => {
            this.legend.style.display = 'none';
        });
    }
}
